import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { canManageWorkspaceTeam } from "@/lib/auxiliaryRoleGuide";
import { buildPendientesPorAuxiliarFromUsers } from "@/modules/despacho/despachoWorkspaceAuxiliaries";

/**
 * Auxiliares activos del workspace para el panel operativo (dueño/supervisor).
 */
export function useDespachoWorkspaceAuxiliaries() {
  const { user } = useAuth();
  const canFetch = canManageWorkspaceTeam(user);
  const [auxiliares, setAuxiliares] = useState([]);
  const [loading, setLoading] = useState(Boolean(canFetch));

  const reload = useCallback(async () => {
    if (!canFetch) {
      setAuxiliares([]);
      setLoading(false);
      return [];
    }
    setLoading(true);
    try {
      const { data } = await api.get("/admin/users");
      const rows = buildPendientesPorAuxiliarFromUsers(Array.isArray(data) ? data : []);
      setAuxiliares(rows);
      return rows;
    } catch {
      setAuxiliares([]);
      return [];
    } finally {
      setLoading(false);
    }
  }, [canFetch]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { auxiliares, loading, canFetch, reload };
}
